export default __webpack_public_path__ + "static/media/badge-level-2.5e9f3acc.png";